import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { selectIsAuthenticated } from '../store/auth/auth.selectors'
import { catchError, map, of, switchMap, take, tap } from 'rxjs'
import { eps } from '../services/url.service'
import { AuthService } from '../services/auth.service'
import { refreshTokenFailure, refreshTokenSuccess } from '../store/auth/auth.actions'

// export const authGuard: CanActivateFn = () => {
//   const router = inject(Router)
//   return inject(Store)
//     .select(selectIsAuthenticated)
//     .pipe(
//       take(1),
//       tap(isAuth => {
//         if (!isAuth) router.navigate([eps.auth.loginPath])
//       }),
//       map(isAuth => isAuth)
//     )
// }

export const authGuard: CanActivateFn = () => {
  const store = inject(Store)
  const authService = inject(AuthService)
  const router = inject(Router)

  return store.select(selectIsAuthenticated).pipe(
    take(1),
    switchMap(isAuth => {
      if (isAuth) {
        return of(true)
      } else {
        // console.log('auth guard')
        // Try to refresh token
        return authService.refreshToken().pipe(
          tap(({ accessToken, user, refreshToken }) => {
            localStorage.setItem('accessToken', accessToken)
            localStorage.setItem('user', JSON.stringify(user))
            localStorage.setItem('refreshToken', refreshToken)
            store.dispatch(refreshTokenSuccess({ accessToken, user }))
          }),
          map(() => true),
          catchError(error => {
            // console.log('error', error)
            store.dispatch(refreshTokenFailure())
            router.navigate([eps.auth.loginPath])
            return of(false)
          })
        )
      }
    })
  )
}
